import React from 'react'
import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { FieldArray } from 'formik'

import { DateTimePicker, Select } from 'components/Forms'
import { hasAccessToThis } from 'services/Utilities'

import { t } from 'translations'
import { Button as MerinioButton, Card } from 'ui'

const UserHiringDataForm = ({ hiringData, disabled }) => {
  const { hiringDataById, hiringData: allHiringData } = useSelector(state => state.resources)
  const hiringDataManage = hasAccessToThis('hiringDataManage')

  return (
    <>
      <h5>{t('manager.users.HIRING_DATA')}</h5>
      <small className="form-text text-muted">{t('manager.users.form.HIRING_DATA_DESCRIPTION')}</small>

      {!allHiringData.length ? (
        <div className="mb-4">
          {hiringDataManage ? (
            <>
              {t('components.addResource.NO_RESOURCES')}
              <div>
                <NavLink to={'/admin/hiringdata'}>{t('components.addResource.ADD_RESOURCES')}</NavLink>
              </div>
            </>
          ) : (
            <>
              {t('components.addResource.NO_RESOURCES')} {t('components.addResource.NO_PERMISSION')}
            </>
          )}
        </div>
      ) : (
        <FieldArray
          name="hiringData"
          render={arrayHelpers => (
            <Card className="bg-light mb-3">
              <div className="p-3">
                {hiringData.map((hd, index) => (
                  <React.Fragment key={index}>
                    <Select
                      module="manager.users.form"
                      name={`hiringData[${index}].hiringDataId`}
                      required
                      translation="hiringDataName"
                      options={allHiringData}
                      disabled={disabled}
                    />
                    {hiringDataById[hd.hiringDataId].hasValidPeriod ? (
                      <>
                        <DateTimePicker
                          module="manager.users.form"
                          name={`hiringData[${index}].start`}
                          translation="hiringDataStart"
                          type="date"
                          disabled={disabled}
                          isClearable
                        />
                        <DateTimePicker
                          module="manager.users.form"
                          name={`hiringData[${index}].end`}
                          translation="hiringDataEnd"
                          type="date"
                          disabled={disabled}
                          isClearable
                        />
                      </>
                    ) : null}

                    {!disabled && (
                      <div style={{ marginTop: '32px' }}>
                        <MerinioButton type="button" color="secondary" onClick={() => arrayHelpers.remove(index)} outlined>
                          <i className="fas fa-trash" />
                        </MerinioButton>
                      </div>
                    )}
                    {!disabled || index !== hiringData.length - 1 ? <hr /> : null}
                  </React.Fragment>
                ))}
                {!disabled && (
                  <MerinioButton
                    type="button"
                    color="secondary"
                    onClick={() => arrayHelpers.push({ hiringDataId: allHiringData[0]._id, type: allHiringData[0].type, start: '', end: '' })}
                    outlined
                  >
                    <i className="fas fa-plus" />
                  </MerinioButton>
                )}
              </div>
            </Card>
          )}
        />
      )}
    </>
  )
}

export default UserHiringDataForm
